import {getReviewsData} from "../reviewsData/reviewsData"

const fetchReviews = () => {
	return getReviewsData()
}

export default fetchReviews
